import { httpApi } from '@/api/http.api'
import type { ServiceOrderKindDto, ServiceOrderOutcomeDto } from '@/api/service-order.api'

/** Zamknięte zlecenie (`ORDER`) albo odrzucone zgłoszenie klienta (`REQUEST`). */
export type ServiceArchiveSourceDto = 'ORDER' | 'REQUEST'

export type ServiceArchiveEntryDto = {
  source: ServiceArchiveSourceDto
  /** Id zlecenia albo zgłoszenia — podgląd prowadzi do szczegółów źródła. */
  id: string
  /** Zgłoszenie nie ma numeru, rodzaju ani terminu realizacji. */
  orderNumber: string | null
  kind: ServiceOrderKindDto | null
  outcome: ServiceOrderOutcomeDto
  archivedAt: string
  /** Dla zgłoszenia — data jego wysłania. */
  orderedAt: string
  expectedAt: string | null
  description: string
  deviceId: string | null
  deviceName: string | null
  deviceType: string | null
  firmId: string | null
  clientName: string | null
  assignee: { id: string; firstName: string | null; lastName: string | null } | null
  cancelReason: string | null
  /** Kody czynności zlecenia; zgłoszenie nie ma czynności. */
  items: { codes: number[] }[]
}

/** `total` liczy wpisy obu źródeł po filtrach — z niego tabela wylicza liczbę stron. */
export type ServiceArchivePageDto = {
  data: ServiceArchiveEntryDto[]
  total: number
  page: number
  limit: number
}

export type ServiceArchiveQuery = {
  search?: string
  outcome?: ServiceOrderOutcomeDto
  /** Zakres daty archiwizacji, RRRR-MM-DD. */
  archivedFrom?: string
  archivedTo?: string
  /** Numer strony od 1; domyślnie 1. */
  page?: number
  /** Wpisów na stronę, 1–100; domyślnie 50. */
  limit?: number
}

const SERVICE_ARCHIVE = 'service-archive'

/** Strona archiwum od najnowszej daty archiwizacji. */
export const getServiceArchive = (query: ServiceArchiveQuery = {}): Promise<ServiceArchivePageDto> =>
  httpApi.get<ServiceArchivePageDto>(SERVICE_ARCHIVE, { params: query }).then(({ data }) => data)
